var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menu.children && _vm.menu.children.length >= 1
    ? _c(
        "el-submenu",
        {
          attrs: {
            index: _vm.menu.id + "",
            "popper-class": "jp-sidebar--" + _vm.sidebarLayoutSkin + "-popper",
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("i", {
              class: _vm.menu.icon + " jp-sidebar__menu-icon",
              staticStyle: { display: "inline-block!important" },
            }),
            _c("span", [_vm._v(_vm._s(_vm.menu.name))]),
          ]),
          _vm._l(_vm.menu.children, function (item) {
            return _c("sub-menu", {
              key: item.id,
              attrs: { menu: item, dynamicMenuRoutes: _vm.dynamicMenuRoutes },
            })
          }),
        ],
        2
      )
    : _c(
        "el-menu-item",
        {
          attrs: { index: _vm.menu.id + "" },
          on: {
            click: function ($event) {
              return _vm.gotoRouteHandle(_vm.menu)
            },
          },
        },
        [
          _c("i", {
            class: _vm.menu.icon + " jp-sidebar__menu-icon",
            staticStyle: { display: "inline-block!important" },
          }),
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.menu.name)),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }